const SARP_SIGNATURE_COUNT_THRESHOLD = 10;

export function petitionHasMinimumSignatures(petitionSignatureCount: number): boolean {
	return petitionSignatureCount >= SARP_SIGNATURE_COUNT_THRESHOLD;
}
